import LazyImage from '@basicComponents/image';
import React from 'react';
import {View} from 'react-native';
import {copyIcon, defaultHeaderImg, emptyHeaderImg} from './me.variable';
import theme from '@/style';
import {useInnerStyle} from './me.hooks';
// import Text from '@basicComponents/text';
import {IUserInfo} from '@/services/global.service';
import dayjs from 'dayjs';
import {NativeTouchableOpacity} from '@basicComponents/touchable-opacity';
import {copyText, goTo} from '@/utils';
import globalStore from '@/services/global.state';
import {useTranslation} from 'react-i18next';
import {SafeAny} from '@/types';
import {flex} from '@/components/style';
import meStyles from './me.module.scss';
// const rightIcon = require('@components/assets/icons/chevron-right.png');

export interface MeUserProps {
  user?: IUserInfo;
  login: boolean;
}
const MeUser: React.FC<MeUserProps> = ({user, login}) => {
  const {i18n} = useTranslation();
  const {
    size: {topInnerHeaderSize},
    userStyle,
  } = useInnerStyle();
  const copy = (content: string) => {
    if (!login) {
      goTo('Login');
      return;
    }
    copyText(content);
    globalStore.globalTotal.next({
      type: 'success',
      message: i18n.t('copy-success'),
    });
  };
  return (
    <NativeTouchableOpacity
      activeOpacity={login ? 1 : 0.8}
      style={[flex.row, flex.between, flex.centerByCol, theme.padding.lrs]}
      onPress={(e: SafeAny) => {
        if (!login) {
          goTo('Login');
        } else {
          e.preventDefault();
          goTo('Profile');
        }
      }}>
      <div
        style={{
          ...theme.margin.btml,
        }}
        className="flex items-center gap-4">
        <View
          style={[
            theme.flex.center,
            userStyle.headerWrap,
            theme.background.white,
          ]}>
          <LazyImage
            width={topInnerHeaderSize}
            height={topInnerHeaderSize}
            imageUrl={
              login
                ? user?.userAvatar
                  ? user.userAvatar
                  : defaultHeaderImg
                : emptyHeaderImg
            }
            occupancy="#0000"
            radius={topInnerHeaderSize / 2}
          />
        </View>
        <div style={{...theme.flex.col}} className="flex gap-2">
          <div className="flex flex-col gap-1">
            <span className={meStyles.me_user_name}>
              {(user?.userName ? user?.userName : user?.userPhone) ||
                i18n.t('me.user.login')}
            </span>
            <div style={{...theme.flex.row}} className="flex gap-2">
              <View
                style={[
                  theme.padding.lrl,
                  theme.padding.tbxxs,
                  userStyle.uid,
                  theme.flex.center,
                  // theme.margin.rights,
                ]}>
                <span className={meStyles.me_user_uuid}>
                  {i18n.t('me.user.uid')}
                  {user ? user.userId : '******'}
                </span>
              </View>
              {user ? (
                <NativeTouchableOpacity onPress={() => copy(user.userId + '')}>
                  <LazyImage
                    imageUrl={copyIcon}
                    occupancy="#0000"
                    width={theme.iconSize.l}
                    height={theme.iconSize.l}
                  />
                </NativeTouchableOpacity>
              ) : null}
            </div>
          </div>
          <span className={meStyles.me_user_uuid}>
            {i18n.t('me.user.lastLogin')}
            {user
              ? dayjs(user.lastLoginTime).format('DD/MM/YYYY hh:mm:ss A')
              : '-'}
          </span>
        </div>
      </div>
      {/* <LazyImage
        occupancy={'transparent'}
        imageUrl={rightIcon}
        width={14}
        height={14}
      /> */}
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          id="Vector"
          d="M1.5 8.34375L5 4.84375L1.5 1.34375"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </NativeTouchableOpacity>
  );
};

export default MeUser;
